<div class="site-page-header-ghost-wrapper">
    <nz-page-header style="padding-left: 0px;" class="site-page-header" nzBackIcon (nzBack)="concluido.emit(true)" nzTitle="Exportação" nzSubtitle=" - Exportação de leads">
    </nz-page-header>

    <form nz-form [formGroup]="form" autocomplete="off" (ngSubmit)="submit()" nzLayout="vertical">
        <div nz-row [nzGutter]="{ md: 24 }">
            <div nz-col nzSpan="12">
                <nz-form-item>
                    <nz-form-label nzRequired>Data Inicial:</nz-form-label>

                    <nz-form-control nzHasFeedback nzErrorTip="Esse campo é obrigatório!">
                        <input nz-input name="data_inicial" type="date" formControlName="data_inicial" />
                    </nz-form-control>
                </nz-form-item>
            </div>
            <div nz-col nzSpan="12">
                <nz-form-item>
                    <nz-form-label nzRequired>Data Final:</nz-form-label>

                    <nz-form-control nzHasFeedback [nzErrorTip]="errorData">
                        <input nz-input name="data_final" type="date" formControlName="data_final" />
                        <ng-template #errorData let-control>
                            <ng-container *ngIf="control.hasError('required')">
                                Esse campo é obrigatório!
                            </ng-container>
                            <ng-container *ngIf="control.hasError('invalid')">
                                Data menor que a inicial!
                            </ng-container>
                        </ng-template>
                    </nz-form-control>
                </nz-form-item>
            </div>

            <div nz-col nzSpan="24">
                <button nz-button nzType="primary" nzBlock>Solicitar</button>
            </div>
        </div>
    </form>
</div>